import { TypographyOptions } from "@mui/material/styles/createTypography";

declare module "@mui/material/styles" {
  interface TypographyVariants {
    body3: React.CSSProperties;
    body4: React.CSSProperties;
    body5: React.CSSProperties;
    body6: React.CSSProperties;
  }
  interface TypographyVariantsOptions {
    body3?: React.CSSProperties;
    body4?: React.CSSProperties;
    body5?: React.CSSProperties;
    body6?: React.CSSProperties;
  }
}

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    body3: true;
    body4: true;
    body5: true;
    body6: true;
  }
}

const typography: TypographyOptions = {
  fontFamily: [
    "Aeonik",
    "Inter",
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
  fontSize: 13,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  h1: {
    fontSize: "3rem",
    lineHeight: 1.0833,
    fontWeight: 700,
  },
  h2: {
    fontSize: "2.5rem",
    fontWeight: 500,
    lineHeight: 1.1,
  },
  h3: {
    fontSize: "2rem",
    fontWeight: 500,
    lineHeight: 1.125,
  },
  h4: {
    fontSize: "1.5rem",
    fontWeight: 500,
    lineHeight: 1.17,
  },
  h5: {
    fontSize: "1.25rem",
    fontWeight: 500,
    lineHeight: 1.2,
  },
  h6: {
    fontSize: "1rem",
    fontWeight: 700,
    lineHeight: 1.25,
  },
  // body-base bold
  body1: {
    fontSize: "1rem", // 16px
    fontWeight: 500,
    lineHeight: 1.25,
  },
  // body-base regular
  body2: {
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: 1.25,
  },
  body3: {
    fontSize: "0.875rem", // 14px
    fontWeight: 400,
    lineHeight: 1.2857,
  },
  body4: {
    fontSize: "0.875rem", // 14px
    fontWeight: 500,
    lineHeight: 1.2857,
  },
  body5: {
    fontSize: "0.75rem", // 12px
    fontWeight: 400, // regular
    lineHeight: 1.3333, // 16px / 12px
  },
  body6: {
    fontSize: "0.75rem", // 12px
    fontWeight: 500, // medium
    lineHeight: 1.3333, // 16px / 12px
  },
  button: {
    textTransform: "none",
  },
};

export default typography;
